import PerformanceList from "./list.vue"
import PerformanceManage from "./manage.vue"
import PerformanceDetails from "./details.vue"


let a = Object.assign({ PerformanceList, PerformanceManage, PerformanceDetails });
export default a;